import { useViewModel } from '@descomplica/microfrontend-react';
import { observer } from 'mobx-react';
import React, { useMemo } from 'react';

import { DataTable } from '@/shared/presentation/components/ui/DataTable';
import { Page } from '@/shared/presentation/components/ui/Page';

import { ScopesViewModel } from './Scopes.vm';

export const ScopesScreen = observer(() => {
  const vm = useViewModel(ScopesViewModel);

  const columns = useMemo(
    () => [
      {
        name: 'GUID',
        selector: (row) => row.guid,
        grow: 2,
        filterable: true,
      },
      {
        name: 'Nome',
        selector: (row) => row.name,
        sortable: true,
        filterable: true,
      },
      {
        name: 'Descrição',
        selector: (row) => row.description || '',
        sortable: true,
        grow: 2,
        filterable: true,
      },
    ],
    [],
  );

  return (
    <Page
      title="Escopos"
      subtitle="Gerencie os escopos das aplicações"
      isLoading={vm.isLoading}
      hasError={vm.hasError}
      errorMessage="Ocorreu um erro ao carregar os escopos"
    >
      <DataTable isLoading={vm.isLoading} columns={columns} data={vm.scopes} actions={[]} />
    </Page>
  );
});
